import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';
import { BaseButtonComponent } from '@d-components/button/button.component';
import { uniqueId } from 'lodash-es';
import { ImageModule } from 'primeng/image';
import { ToastService } from '@d-services';
import { ToastType } from '@d-constants';

export const DEFAULT_AVATAR_URL = 'assets/images/default-avartar.jpg';
export const MAX_FILE_SIZE = 5; // Mb
@Component({
  selector: 'app-avatar-selector',
  templateUrl: './avatar-selector.component.html',
  styleUrls: ['./avatar-selector.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    ToastModule,
    TooltipModule,
    ImageModule,
    BaseButtonComponent,
  ],
})
export class AvatarSelectorComponent {
  @ViewChild('avatarInput')
  avatarInputVariable!: ElementRef;
  inputId = 'PO-avatar-input-' + uniqueId();
  acceptTypes: string[] = ['.bmp', '.jpg', '.jpeg', '.png', '.gif'];
  @Input() enableChooseFile: boolean = true;
  @Input() cssContainer: string = 'border-circle';
  @Output() onAvatarSelected = new EventEmitter<any>();
  @Output() onLoadAvatarURL = new EventEmitter<any>();
  @Output() onRemoveAvatar = new EventEmitter<any>();
  @Input() disabled: boolean = false;

  _avatarURL: string = DEFAULT_AVATAR_URL;
  get avatarURL(): string {
    return this._avatarURL;
  }
  @Input() set avatarURL(value: string) {
    if (value) {
      this._avatarURL = value;
    } else {
      this._avatarURL = DEFAULT_AVATAR_URL;
    }
  }

  constructor(private toastService: ToastService) {}

  onSelectPoAvatar(event: any) {
    let file = event?.target?.files.length > 0 ? event.target.files[0] : null;
    if (file) {
      if (!this.isValidMaxSize(file.size)) {
        this.toastService.addSingle({
          type: ToastType.ERROR,
          summary: '',
          message: 'INVALID_IMAGE_SIZE',
        });
        this.removeAvatar();
        return;
      }

      if (!this.isValidFileType(file.name)) {
        this.toastService.addSingle({
          type: ToastType.ERROR,
          summary: '',
          message: 'INVALID_IMAGE_TYPES',
          messageParams: {
            file_name: file.name,
          },
        });
        this.removeAvatar();
        return;
      }
      let reader = new FileReader();
      reader.onload = async (event: any) => {
        this.avatarURL = await event.target.result;
        this.onLoadAvatarURL.emit(event.target.result);
      };
      reader.readAsDataURL(event.target.files[0]);
      this.onAvatarSelected.emit(event.target.files[0]);
    }
  }

  openFileExplorer() {
    document.getElementById(this.inputId)?.click();
  }

  removeAvatar() {
    this.avatarInputVariable.nativeElement.value = null;
    this.avatarURL = DEFAULT_AVATAR_URL;
    this.onRemoveAvatar.emit();
  }

  isValidMaxSize(_fileSize: number) {
    let fileSizeToMb = this.formatBytesToMb(_fileSize);
    return fileSizeToMb <= MAX_FILE_SIZE;
  }

  formatBytesToMb(bytes: number, decimals = 3) {
    if (bytes === 0) return 0;
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    return parseFloat((bytes / Math.pow(k, 2)).toFixed(dm));
  }

  isValidFileType(fileName: string) {
    var fileExtension =
      '.' + fileName.split('.').pop()?.toLocaleLowerCase() ?? '';
    return this.acceptTypes.includes(fileExtension);
  }
}
